import * as Yup from 'yup';

export default function validationSchema() {
  return Yup.object({
    username: Yup.string().required(),
    password: Yup.string().required()
  });
}
